import { Chip } from "@mui/material";
import { existsString } from "../../store/validation";
import { useExportCommit } from "../../store/exportCommit/hooks";

export default function ExportStatus() {
  const { exportStatus } = useExportCommit();

  const getColor = (status) => {
    if (existsString(status)) {
      if (status[0] === "D") return "#00b976";
      if (status[0] === "Q") return "#0288d1";
      return "#b000f0";
    }
    return "#0288d1";
  };

  const formatStatus = (status) => {
    if (existsString(status)) {
      return status.replaceAll("_", " ");
    } else {
      return status;
    }
  };

  const label = formatStatus(exportStatus);
  const color = getColor(exportStatus);

  return <Chip sx={{ backgroundColor: color, color: "white" }} label={label} />;
}
